import updateIn from 'transmute/updateIn';
export default updateIn;